import { DEFAULT_BORDER } from 'constants/global';

import Ball from 'assets/icons/ball.svg';
import Love from 'assets/icons/love.svg';
import Notes from 'assets/icons/notes.svg';

const sameProps = {
  boxSize: 'unset',
  w: { mobile: 'full', xm: '340px', laptop: '600px', desktop: '670px' },
  minH: { mobile: '320px', laptop: '440px', desktop: '600px' },
  p: { mobile: '60px 24px 24px', laptop: '0 48px 48px' },
};

export const aboutUsExpertiseCardsSliderProps = {
  title: (
    <>
      ASTON и социальная <br /> ответственность
    </>
  ),

  cardsData: [
    {
      src: Ball,
      title: 'Окружающая среда',
      text: 'Мы заботимся об окружающей среде — создаём энергоэффективные офисы, сортируем мусор и перерабатываем его, а также проводим экологические акции, например, «Расти в ИТ!»',
    },
    {
      src: Love,
      title: 'Забота о сотрудниках',
      text: 'В компании уделяют внимание здоровью сотрудников. Каждый специалист получает ДМС, оплачиваемые дни по болезни (sick-days), отпуск, возмещение затрат на спорт и участие во всех корпоративных мероприятиях',
    },
    {
      src: Notes,
      title: 'Обмен знаниями',
      text: 'Команда ASTON верит, что знания делают нас лучше. Мы создаём условия для роста и обмена опытом: развиваем собственную обучающую площадку, регулярно проводим онлайн-семинары и встречи (митапы) для ИТ-специалистов',
    },
  ],

  cardsStyles: [
    { bgColor: 'bg.accent', ...sameProps },
    {
      bgColor: 'bg.white',
      border: DEFAULT_BORDER,
      borderColor: 'line.gray',
      iconProps: { bgColor: 'bg.gray' },
      ...sameProps,
    },
    { bgColor: 'bg.gray', ...sameProps },
  ],
};
